import React from "react";
import { Globe } from "lucide-react";
import { TIMEZONE_GROUPS, BASE_TZ, zoneLabel } from "@/lib/timezone";
import { useTimezone } from "@/contexts/TimezoneContext";

/**
 * Compact timezone dropdown. Grouped by region.
 * variant: "full" shows label; "compact" shows just the icon + short code.
 */
export default function TimezoneSelector({ variant = "full", className = "" }) {
  const { timezone, setTimezone, isBase } = useTimezone();
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="timezone-selector">
      <Globe size={14} className="text-[var(--ff-text-dim)]" />
      {variant === "full" && (
        <span className="font-mono-ui text-[0.65rem] uppercase tracking-[0.15em] text-[var(--ff-text-dim)] hidden sm:inline">
          Timezone
        </span>
      )}
      <select
        value={timezone}
        onChange={(e) => setTimezone(e.target.value)}
        data-testid="timezone-selector-dropdown"
        className="bg-[var(--ff-bg)] border border-[var(--ff-border)] text-white font-mono-ui text-xs uppercase tracking-[0.1em] px-2 py-1.5 hover:border-[var(--ff-red)] focus:border-[var(--ff-red)] focus:outline-none cursor-pointer"
        title={zoneLabel(timezone)}
      >
        {TIMEZONE_GROUPS.map((g) => (
          <optgroup key={g.label} label={g.label}>
            {g.zones.map((z) => (
              <option key={z.value} value={z.value} data-testid={`timezone-option-${z.value}`}>
                {z.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      {!isBase && (
        <button
          onClick={() => setTimezone(BASE_TZ)}
          data-testid="timezone-reset-btn"
          className="font-mono-ui text-[0.6rem] uppercase tracking-[0.15em] text-[var(--ff-red)] hover:text-white transition-colors"
          title="Reset to US Eastern (base)"
        >
          Reset
        </button>
      )}
    </div>
  );
}
